import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { InputTextField } from '../components/Input/InputTextField';
import { Search } from 'lucide-react';
import { useData } from '../hooks/useData';
import CodeSearchTab from '../components/Codes/CodeSearchTab';
import { createCustomToast } from '../utils/data';
import { InputSlider } from '../components/Input/InputSlider';
import { renderPercentColor } from '../utils/tools';

const Lookup = () => {
  const { theme } = useTheme();
  const { lookupLoading, codes, searchCodes, handleSearchCodes, fetchCodeLookups } = useData();

  const [search, setSearch] = useState('');
  const [markupPercent, setMarkupPercent] = useState(150);

  // Add code to array with duplicate check and toast
  const addToCodeArray = (code, remaining = '') => {
    code = code?.toUpperCase();
    if (!code) return;
    if (searchCodes.includes(code)) {
      createCustomToast('Duplicate code.', theme);
      setSearch(remaining);
      return;
    }
    handleSearchCodes([ code, ...searchCodes ], theme);
    setSearch(remaining);
  };

  const handleSearch = (value) => {
    const codeValue = value.toUpperCase();
    if (!/^[A-Z0-9]*$/.test(codeValue)) {
      return;
    }
    if (codeValue.length >= 6) {
      let firstFive = codeValue.substring(0, 5);
      let remainingChars = codeValue.substring(5);
      addToCodeArray(firstFive, remainingChars);
    } else {
      setSearch(codeValue);
    }
  };

  function handlePaste(value){
	let c = (value.toUpperCase().match(/\b(?:\d{5}|[A-Z]\d{4})\b/g) || []);

	let ac = [...c, ...searchCodes];
	
	let uc = [...new Set(ac)];
	let newCodeCount = uc.length - searchCodes.length;
	handleSearchCodes(uc, theme);
	setSearch('');
	
	createCustomToast(`${newCodeCount > 0 ? newCodeCount : 'No'} code${newCodeCount > 1 ? 's' : ''} added.`, theme);

	

	  }

  const handleCloseClick = (code) => {
    handleSearchCodes(searchCodes.filter(c => c !== code), theme);
  }

  const clearAllCodes = () => {
    handleSearchCodes([]);
	setSearch('');
  }

  const changeMarkupPercent = (v) => {

    setMarkupPercent(v);
  }

  useEffect(() => {
    const missingCodes = searchCodes.filter(code => codes[code] === undefined);
    if (missingCodes.length > 0) {
      fetchCodeLookups(missingCodes);
    }
    // Fetch only when the selected code list changes; pricing updates populate `codes`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchCodes]);

	return (
		<div className="main-content page-lookup">
			<section className="lookup-toolbar">
				<div className="lookup-heading">
					<div>
						<h1>Code pricing lookup</h1>
						<p>Enter a 5-digit code.</p>
					</div>
				</div>
				<div className="lookup-controls">
					<div className="lookup-search">
						<InputTextField
							focus={true}
							groupStyle={{margin: 0, width: '100%'}}
							style={{fontSize: 16}}
							onChange={handleSearch}
							onPaste={handlePaste}
							placeholder='Search by code'
							value={search}
							endIcon={<Search size={22} />}
						/>
					</div>
					{searchCodes.length > 0 && (
						<div className="lookup-actions">
							<div className="lookup-markup">
								<p className='data-label small'>Markup</p>
								<InputSlider
									title={null}
									value={markupPercent}
									onChange={changeMarkupPercent}
									min={100}
									max={500}
									step={25}
								/>
								<p className='percent'>{renderPercentColor(markupPercent, true)}<span className="muted">%</span></p>
							</div>
							<button className="lookup-clear-button" onClick={clearAllCodes}>Clear all</button>
						</div>
					)}
					</div>
			</section>
			
			
			
			{ searchCodes.length > 0 ? (
				<div className="code-search-tab-grid">
					{searchCodes.map((code) => (
						<CodeSearchTab loading={lookupLoading && codes[code] === undefined} markupPercent={markupPercent} onCloseClick={handleCloseClick} key={code} code={code} />
					))}
				</div>
			):(
				<div className="lookup-empty-state">
					<Search size={28} />
					<p>Type one code, or paste multiple codes separated by commas, spaces, or new lines.</p>
				</div>
			)}
			
		


		</div>
	);
};

export default Lookup; 
